export default "__VITE_ASSET__DFrNT8Um__"